import { gql } from '@apollo/client/core';

export const videoEmbedBlockFragment = gql`
  fragment VideoEmbedBlockFields on VideoEmbedBlock {
    entryTitle
    videoUrl
    videoTitle
    fallbackImage {
      url
      title
      __typename
    }
    __typename
  }
`;
